export default "__VITE_PUBLIC_ASSET__cf6f4c96__"